import React from 'react';
import {
  DropdownButton,
  FormGroup,
  HelpBlock,
  MenuItem,
} from 'react-bootstrap';
import Empty from './Empty.jsx';
import { CloseIcon } from './icons/CloseIcon.jsx';
import styles from './MultiSelect.module.css';

const MultiSelect = (props) => {
  const {
    multiple = true, // false doesn't merge result as [...current, new].
    options,
    selectedOptions,
    updateSelectedOptions,
    additionalFields,
    placeholder,
    subject,
    nameKey,
    deleteMsg,
    customClass,
    disabled,
    error,
  } = props;
  const handleRemove = (id) => {
    if (
      !window.confirm(
        deleteMsg || `Are you sure you want to detach this ${subject}?`
      )
    )
      return;

    updateSelectedOptions(selectedOptions.filter((item) => item.id !== id));
  };

  const handleSelect = (id) => {
    if (multiple) {
      updateSelectedOptions([...selectedOptions, { id, ...additionalFields }]);
    } else {
      updateSelectedOptions([{ id, ...additionalFields }]);
    }
  };

  const isActive = (id) => !!selectedOptions.find((item) => item.id === id);

  const filteredDraftItems = (arr) => arr.filter((item) => 'id' in item);

  const renderMenuItem = (item) => (
    <React.Fragment key={item.id}>
      <MenuItem
        active={isActive(item.id)}
        eventKey={item}
        onSelect={() =>
          isActive(item.id) ? handleRemove(item.id) : handleSelect(item.id)
        }
      >
        <span
          className={`${item.archived && !isActive(item.id) ? 'text-muted' : ''}`}
        >
          {item[nameKey] || ''} {item.archived ? '(archived)' : ''}
        </span>
      </MenuItem>
      {item.children?.length > 0 && (
        <li>
          <ul className={styles.itemsFilterSubmenu}>
            {item.children.map(renderMenuItem)}
          </ul>
        </li>
      )}
    </React.Fragment>
  );

  const renderSelectedItem = (id) => {
    const item = options.find((item) => item.id === id);

    const name = item ? item[nameKey] : '';
    return (
      <div key={id} className="flex m-t-4 m-l-4 item-style">
        {name}
        {item && 'archived' in item && item.archived ? '(archived)' : ''}
        <span
          className="btn btn-clear close-btn"
          onClick={() => handleRemove(id)}
        >
          <CloseIcon />
        </span>
      </div>
    );
  };

  return options ? (
    <div className={`${styles.itemsBulkSelect} m-b-24 ${customClass}`}>
      <FormGroup validationState="error" className="m-b-0">
        <div className="bulk-select m-b-12">
          <div className="flex flex-align-start flex-wrap">
            {filteredDraftItems(selectedOptions).map((item) =>
              renderSelectedItem(item.id)
            )}
          </div>
          <DropdownButton
            title={placeholder}
            bsStyle="info"
            id={`${subject}-select`}
            disabled={disabled}
            style={{
              padding: '8px 15px',
              width: '100%',
              color: '#999999',
              fontWeight: '400',
            }}
            className="dropdown-toggle btn btn-info btn-clear btn-no-left-border"
          >
            {options.length > 0 ? (
              options.map(renderMenuItem)
            ) : (
              <MenuItem disabled>No options available</MenuItem>
            )}
          </DropdownButton>
        </div>
        <HelpBlock>{error}</HelpBlock>
      </FormGroup>
    </div>
  ) : (
    <Empty simplified />
  );
};

export default MultiSelect;
